import { render, staticRenderFns } from "./BalanceView.vue?vue&type=template&id=19fe18cf&scoped=true&"
import script from "./BalanceView.vue?vue&type=script&lang=js&"
export * from "./BalanceView.vue?vue&type=script&lang=js&"
import style0 from "./BalanceView.vue?vue&type=style&index=0&id=19fe18cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fe18cf",
  null
  
)

export default component.exports